import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { layoutDataSelector } from 'ducks/layoutData'

import { Container, TermsContent, Text, TextLink } from './styled'
import Checkbox from '../Checkbox'

type Props = {
  checked: boolean
  handleCheckbox: () => void
  checkboxColor?: string
  error?: string
}

const PrivacyTerms: FC<Props> = ({ checked, handleCheckbox, checkboxColor, error }) => {
  const layoutState = useSelector(layoutDataSelector)
  const termsAndPolicy = layoutState.get('termsAndPolicy')
  return (
    <Container>
      <Checkbox error={error} color={checkboxColor} value={checked} onChange={handleCheckbox} />
      <TermsContent>
        <Text>
          {termsAndPolicy?.getIn(['privacy_policy', 'description'])}{' '}
          <TextLink target="blank" to={termsAndPolicy?.getIn(['privacy_policy', 'link']) || ''}>
            {termsAndPolicy?.getIn(['privacy_policy', 'link_label'])}
          </TextLink>{' '}
        </Text>
      </TermsContent>
    </Container>
  )
}

export default PrivacyTerms
